import { isArray, isNil, isValid } from "@visactor/vutils";

import { ComponentTypeEnum } from "../interface/type";

import { isDiscrete } from "@visactor/vscale";

import { LineCrosshair, RectCrosshair, Tag } from "@visactor/vrender-components";

import { BaseCrossHair } from "./base";

import { limitTagInBounds } from "./utils";

import { isXAxis, isYAxis } from "../axis/cartesian/util/common";

import { Factory } from "../../core/factory";

import { layoutByValue, layoutHorizontalCrosshair, layoutVerticalCrosshair } from "./utils/cartesian";

import { getFirstSeries } from "../../util";

export class CartesianCrossHair extends BaseCrossHair {
    static getSpecInfo(chartSpec) {
        const crosshairSpec = chartSpec[this.specKey];
        if (isNil(crosshairSpec)) return;
        if (!isArray(crosshairSpec)) return crosshairSpec.xField && !1 !== crosshairSpec.xField.visible || crosshairSpec.yField && !1 !== crosshairSpec.yField.visible ? [ {
            spec: crosshairSpec,
            specPath: [ this.specKey ],
            specInfoPath: [ "component", this.specKey, 0 ],
            type: ComponentTypeEnum.cartesianCrosshair
        } ] : void 0;
        const specInfos = [];
        return crosshairSpec.forEach(((s, i) => {
            (s.xField && !1 !== s.xField.visible || s.yField && !1 !== s.yField.visible) && specInfos.push({
                spec: s,
                specPath: [ this.specKey, i ],
                specInfoPath: [ "component", this.specKey, i ],
                type: ComponentTypeEnum.cartesianCrosshair
            });
        })), specInfos;
    }
    constructor(spec, options) {
        super(spec, options), this.type = ComponentTypeEnum.cartesianCrosshair, this.name = ComponentTypeEnum.cartesianCrosshair, 
        this._currValueX = new Map, this._currValueY = new Map;
    }
    _showDefaultCrosshairBySpec() {
        const {xField: xField, yField: yField} = this._spec;
        if ((null == xField ? void 0 : xField.visible) && xField.defaultSelect) {
            const {axisIndex: axisIndex, datum: datum} = xField.defaultSelect;
            this._defaultCrosshair(axisIndex, datum, 1);
        }
        if ((null == yField ? void 0 : yField.visible) && yField.defaultSelect) {
            const {axisIndex: axisIndex, datum: datum} = yField.defaultSelect;
            this._defaultCrosshair(axisIndex, datum, 2);
        }
    }
    _defaultCrosshair(axisIndex, value, tag) {
        const axis = this._option.getComponentsByKey("axes").find((c => c.getSpecIndex() === axisIndex));
        axis && (1 === tag ? (this._currValueX.clear(), this._currValueX.set(axisIndex, {
            axis: axis,
            value: value
        })) : (this._currValueY.clear(), this._currValueY.set(axisIndex, {
            axis: axis,
            value: value
        })), this.layoutByValue(tag));
    }
    _findAllAxisContains(relativeX, relativeY) {
        const xAxisMap = this._getAxisInfoByField("x"), yAxisMap = this._getAxisInfoByField("y");
        return {
            xAxisMap: this._filterAxisByPoint(xAxisMap, relativeX, relativeY),
            yAxisMap: this._filterAxisByPoint(yAxisMap, relativeX, relativeY)
        };
    }
    _getValueAt(axis, p) {
        return axis.getScale().invert(p);
    }
    clearAxisValue() {
        this._currValueX.clear(), this._currValueY.clear();
    }
    setAxisValue(value, axis) {
        isXAxis(axis.getOrient()) ? this._currValueX.set(axis.getSpecIndex(), {
            value: value,
            axis: axis
        }) : this._currValueY.set(axis.getSpecIndex(), {
            value: value,
            axis: axis
        });
    }
    _getAllAxisValues(axisMap, p, currValue, vertical) {
        let discrete = !1;
        return axisMap.forEach((item => {
            isDiscrete(item.axis.getScale().type) && (discrete ? this.enable = !1 : discrete = !0);
        })), !!this.enable && (axisMap.forEach(((item, id) => {
            const axis = item.axis;
            currValue.set(id, {
                value: this._getValueAt(axis, p - (vertical ? axis.getLayoutStartPoint().x - this.getLayoutStartPoint().x : axis.getLayoutStartPoint().y - this.getLayoutStartPoint().y)),
                axis: axis
            });
        })), !0);
    }
    _layoutCrosshair(relativeX, relativeY, tooltipData, activeType) {
        var _a;
        let x = relativeX, y = relativeY;
        if (tooltipData && tooltipData.length) if ("dimension" === activeType) {
            const dimensionInfo = tooltipData[0], datumIndex = dimensionInfo.data.findIndex((dimData => dimData.datum.length > 0));
            let pos;
            if (datumIndex > -1) {
                const dimensionData = dimensionInfo.data[datumIndex];
                pos = dimensionData.series.dataToPosition(dimensionData.datum[0]);
            }
            (isValid(dimensionInfo.dimType) ? "y" === dimensionInfo.dimType : isYAxis(null === (_a = null == dimensionInfo ? void 0 : dimensionInfo.axis) || void 0 === _a ? void 0 : _a.getOrient())) ? y = null == pos ? void 0 : pos.y : x = null == pos ? void 0 : pos.x;
        } else if ("mark" === activeType) {
            const dimensionData = tooltipData[0], pos = dimensionData.series.dataToPosition(dimensionData.datum[0]);
            x = null == pos ? void 0 : pos.x, y = null == pos ? void 0 : pos.y;
        }
        const {xAxisMap: xAxisMap, yAxisMap: yAxisMap} = this._findAllAxisContains(x, y);
        if (xAxisMap && 0 === xAxisMap.size || yAxisMap && 0 === yAxisMap.size) {
            if (this.enableRemain) return;
            this.hide();
        } else this._currValueX.clear(), this._currValueY.clear(), xAxisMap && xAxisMap.size && this._getAllAxisValues(xAxisMap, x, this._currValueX, !0), 
        yAxisMap && yAxisMap.size && this._getAllAxisValues(yAxisMap, y, this._currValueY, !1), 
        this.layoutByValue(3);
    }
    hide() {
        this._xCrosshair && this._xCrosshair.hideAll(), this._xTopLabel && this._xTopLabel.hideAll(), 
        this._xBottomLabel && this._xBottomLabel.hideAll(), this._yCrosshair && this._yCrosshair.hideAll(), 
        this._yLeftLabel && this._yLeftLabel.hideAll(), this._yRightLabel && this._yRightLabel.hideAll();
    }
    layoutByValue(tag = 3) {
        if (!this.enable) return;
        const series = getFirstSeries(this._regions, "cartesian");
        if (!series) return;
        const {x: x, y: y, offsetWidth: offsetWidth, offsetHeight: offsetHeight, bandWidth: bandWidth, bandHeight: bandHeight} = layoutByValue(tag, series, this.getLayoutStartPoint(), this._currValueX, this._currValueY, this._xHair, this._yHair, this.enableRemain, this._cacheXCrossHairInfo, this._cacheYCrossHairInfo);
        this.enableRemain && (x && (this._cacheXCrossHairInfo = Object.assign(Object.assign({}, x), {
            _isCache: !0
        })), y && (this._cacheYCrossHairInfo = Object.assign(Object.assign({}, y), {
            _isCache: !0
        }))), x && this._layoutVertical(x, bandWidth, offsetWidth), y && this._layoutHorizontal(y, bandHeight, offsetHeight);
    }
    _layoutVertical(crosshairInfo, bandWidth, offsetWidth) {
        var _a, _b;
        if (crosshairInfo._isCache && this.enableRemain || !this._xHair) return;
        const {x: x, topPos: topPos, height: height, top: top, bottom: bottom, visible: visible} = crosshairInfo;
        if (visible) {
            const type = this._xHair.type, positionAttribute = layoutVerticalCrosshair(this._xHair, crosshairInfo, bandWidth, offsetWidth);
            if (this._updateCrosshair("x", type, positionAttribute), top.visible) {
                const updateAttrs = Object.assign(Object.assign(Object.assign({
                    x: x + bandWidth / 2,
                    y: topPos
                }, top), this._xHair.label), {
                    textStyle: Object.assign(Object.assign({}, null === (_a = this._xHair.label) || void 0 === _a ? void 0 : _a.textStyle), {
                        textAlign: "center",
                        textBaseline: "bottom"
                    }),
                    zIndex: this.labelZIndex,
                    visible: !0
                });
                this._updateCrosshairLabel(this._xTopLabel, updateAttrs, (label => {
                    label.name = "crosshair-x-top-label", this._xTopLabel = label;
                }));
            } else this._xTopLabel && this._xTopLabel.hideAll();
            if (bottom.visible) {
                const updateAttrs = Object.assign(Object.assign(Object.assign({
                    x: x + bandWidth / 2,
                    y: topPos + height
                }, bottom), this._xHair.label), {
                    textStyle: Object.assign(Object.assign({}, null === (_b = this._xHair.label) || void 0 === _b ? void 0 : _b.textStyle), {
                        textAlign: "center",
                        textBaseline: "top"
                    }),
                    zIndex: this.labelZIndex,
                    visible: !0
                });
                this._updateCrosshairLabel(this._xBottomLabel, updateAttrs, (label => {
                    label.name = "crosshair-x-bottom-label", this._xBottomLabel = label;
                }));
            } else this._xBottomLabel && this._xBottomLabel.hideAll();
        }
    }
    _layoutHorizontal(crosshairInfo, bandHeight, offsetHeight) {
        var _a, _b;
        if (crosshairInfo._isCache && this.enableRemain || !this._yHair) return;
        const {leftPos: leftPos, width: width, y: y, left: left, right: right, visible: visible} = crosshairInfo;
        if (visible) {
            const type = this._yHair.type, positionAttribute = layoutHorizontalCrosshair(this._yHair, crosshairInfo, bandHeight, offsetHeight);
            if (this._updateCrosshair("y", type, positionAttribute), left.visible) {
                const updateAttrs = Object.assign(Object.assign(Object.assign({
                    x: leftPos,
                    y: y + bandHeight / 2
                }, left), this._yHair.label), {
                    textStyle: Object.assign(Object.assign({}, null === (_a = this._yHair.label) || void 0 === _a ? void 0 : _a.textStyle), {
                        textAlign: "right",
                        textBaseline: "middle"
                    }),
                    zIndex: this.labelZIndex
                });
                this._updateCrosshairLabel(this._yLeftLabel, updateAttrs, (label => {
                    label.name = "crosshair-y-left-label", this._yLeftLabel = label;
                }));
            } else this._yLeftLabel && this._yLeftLabel.hideAll();
            if (right.visible) {
                const updateAttrs = Object.assign(Object.assign(Object.assign({
                    x: leftPos + width,
                    y: y + bandHeight
                }, right), this._yHair.label), {
                    textStyle: Object.assign(Object.assign({}, null === (_b = this._yHair.label) || void 0 === _b ? void 0 : _b.textStyle), {
                        textAlign: "left",
                        textBaseline: "middle"
                    }),
                    zIndex: this.labelZIndex
                });
                this._updateCrosshairLabel(this._yRightLabel, updateAttrs, (label => {
                    label.name = "crosshair-y-right-label", this._yRightLabel = label;
                }));
            } else this._yRightLabel && this._yRightLabel.hideAll();
        }
    }
    _parseFieldInfo() {
        const {xField: xField, yField: yField} = this._spec;
        xField && xField.visible && (this._xHair = this._parseField(xField, "xField")), 
        yField && yField.visible && (this._yHair = this._parseField(yField, "yField"));
    }
    _updateCrosshair(dim, type, attributes) {
        const container = this.getContainer();
        let crosshair;
        if (crosshair = "x" === dim ? this._xCrosshair : this._yCrosshair, crosshair) crosshair.setAttributes(attributes); else {
            const style = "x" === dim ? this._xHair.style : this._yHair.style;
            "line" === type ? crosshair = new LineCrosshair(Object.assign(Object.assign({}, attributes), {
                lineStyle: style,
                zIndex: this.gridZIndex + 1,
                disableTriggerEvent: this._option.disableTriggerEvent,
                pickable: !1
            })) : "rect" === type && (crosshair = new RectCrosshair(Object.assign(Object.assign({}, attributes), {
                rectStyle: style,
                zIndex: this.gridZIndex,
                disableTriggerEvent: this._option.disableTriggerEvent,
                pickable: !1
            }))), null == container || container.add(crosshair), "x" === dim ? this._xCrosshair = crosshair : this._yCrosshair = crosshair;
        }
    }
    _updateCrosshairLabel(label, attributes, callback) {
        const container = this.getContainer();
        label ? label.setAttributes(attributes) : (callback(label = new Tag(attributes)), 
        null == container || container.add(label)), limitTagInBounds(label, this._getLimitBounds());
    }
    _getNeedClearVRenderComponents() {
        return [ this._xCrosshair, this._xTopLabel, this._xBottomLabel, this._yCrosshair, this._yLeftLabel, this._yRightLabel ];
    }
}

CartesianCrossHair.specKey = "crosshair", CartesianCrossHair.type = ComponentTypeEnum.cartesianCrosshair;

export const registerCartesianCrossHair = () => {
    Factory.registerComponent(CartesianCrossHair.type, CartesianCrossHair);
};
//# sourceMappingURL=cartesian.js.map
